import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import AppleIcon from '@mui/icons-material/Apple';
import { useTranslation } from 'react-i18next';
import SpotifyIcon from '../assets/icons/SpotifyIcon';
import YouTubeIcon from '@mui/icons-material/YouTube';
import AmazonMusicIcon from '../assets/icons/AmazonMusicIcon';
import YouTubeMusicIcon from '../assets/icons/YouTubeMusicIcon';
import { Typography } from '@mui/material';

const releases = [
  {
    id: 'lamer',
    title: 'Lamer',
    subtitle: 'Single · 2026',
    coverUrl: 'https://pushforward.online/static/media/images/Lamer400.png',
    coverAlt: 'Lamer album cover',
    links: [
      {
        label: 'Apple Music',
        href: 'https://music.apple.com/us/album/lamer-single/6811264463',
        icon: <AppleIcon />,
      },
      {
        label: 'Spotify',
        href: 'https://open.spotify.com/album/0RfO9w6egmMJRgOe75oelO?si=DBs2906wR3CH4hHSrTTaww',
        icon: <SpotifyIcon />,
      },
      {
        label: 'YouTube Music',
        href: 'https://music.youtube.com/watch?v=Ty478CShp_Q&si=wOGrlBwi-N1H61vZ',
        icon: <YouTubeMusicIcon />,
      },
      {
        label: 'YouTube',
        href: 'https://www.youtube.com/watch?v=Ty478CShp_Q',
        icon: <YouTubeIcon />,
      },
      {
        label: 'Amazon Music',
        href: 'https://music.amazon.ca/albums/B0HJL1MXVV?marketplaceId=ART4WZ8MWBX2Y&musicTerritory=CA&ref=dm_sh_hiTeWuCzbKcrqfbZBQYgYtll8&trackAsin=B0HJLQRGDG',
        icon: <AmazonMusicIcon />,
      },
    ],

  },
  {
    id: 'little-sunflower',
    title: 'Little Sunflower',
    subtitle: 'Single · 2026',
    coverUrl: 'https://pushforward.online/static/media/images/LittleSunflower400.png',
    coverAlt: 'Little Sunflower album cover',
    links: [
      {
        label: 'Apple Music',
        href: 'https://music.apple.com/us/album/little-sunflower-single/6778273913',
        icon: <AppleIcon />,
      },
      {
        label: 'Spotify',
        href: 'https://open.spotify.com/album/4mzTtVjSkPVF8kpYBlTiWX?si=uQg3PEnVRE-fqU0dn2SVOw',
        icon: <SpotifyIcon />,
      },
      {
        label: 'YouTube Music',
        href: 'https://music.youtube.com/watch?v=_zC86uF254A&si=KJOKyoDn_ogent6p',
        icon: <YouTubeMusicIcon />,
      },
      {
        label: 'YouTube',
        href: 'https://youtu.be/Wu2hV7VRhIA',
        icon: <YouTubeIcon />,
      },
      {
        label: 'Amazon Music',
        href: 'https://amazon.ca/music/player/albums/B0H4M2Y86N?marketplaceId=A2EUQ1WTGCTBG2&musicTerritory=CA&ref=dm_sh_6bQfO2mO8vUXeCg4yYfGUh3xp',
        icon: <AmazonMusicIcon />,
      },
    ],
  },
  {
    id: 'pousse',
    title: 'Poussé',
    subtitle: 'Album · 2024',
    coverUrl: 'https://pushforward.online/static/media/images/Push_Forward_Pousse_Album_Cover_400.png',
    coverAlt: 'Poussé album cover',
    links: [
      {
        label: 'Apple Music',
        href: 'https://music.apple.com/us/album/pouss%C3%A9/1777566553',
        icon: <AppleIcon />,
      },
      {
        label: 'Spotify',
        href: 'https://open.spotify.com/album/2ge6ZrABuxbjHVkVTJm0Nw?si=VVsm1l_gR8yBB7GW0K9wOQ',
        icon: <SpotifyIcon />,
      },
      {
        label: 'YouTube Music',
        href: 'https://music.youtube.com/playlist?list=OLAK5uy_lXY01JlPrJqisKWA9QJOfIvZ_hkz8hBYU&si=8rMNkZz7eViagM2D',
        icon: <YouTubeMusicIcon />,
      },
      {
        label: 'YouTube',
        href: 'https://www.youtube.com/playlist?list=PLkZQOXj8KXiJ6xVpngSR1j4m14Ek-CtSo',
        icon: <YouTubeIcon />,
      },
      {
        label: 'Amazon Music',
        href: 'https://amazon.ca/music/player/albums/B0DLF7LD2F?marketplaceId=A2EUQ1WTGCTBG2&musicTerritory=CA&ref=dm_sh_8TIxQr2Kb2HjtxmvGRguzbr1C',
        icon: <AmazonMusicIcon />,
      },
    ],
  },
];

const Music = () => {
  const { t } = useTranslation();

  return (
    <Container disableGutters={true} maxWidth={false} className='container'>
      {releases.map((release) => (
        <Box key={release.title} id={release.id} className='banner'>
          <h1 className='musicPageTitle'>{release.title}</h1>
          <Typography className='musicAvailableNote'>{release.subtitle}</Typography>

          <Box className='bannerMusic'>
            <img
              className='albumCover'
              src={release.coverUrl}
              alt={release.coverAlt}
            />
          </Box>

          <Box className='streamButtons'>
            {release.links.map(({ label, href, icon }) => (
              <Button
                key={label}
                className='streamMusicButton'
                href={href}
                target='_blank'
                rel='noreferrer'
                variant='contained'
                startIcon={icon}
              >
                {label}
              </Button>
            ))}
          </Box>

          <Typography className='musicAvailableNote'>
            {t('music.also_available_on_favorite_service')}
          </Typography>
        </Box>
      ))}
    </Container>
  );
};

export default Music;
